import { useContext } from "react";
import { HookOutOfContextError } from "@jugl-web/utils";
import { NotificationsContext } from "./NotificationsContext";

export const useNotifications = () => {
  const context = useContext(NotificationsContext);

  if (!context) {
    throw new HookOutOfContextError(
      "useInAppNotifications",
      "NotificationsContext"
    );
  }

  return context;
};
